import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MaskFieldsService {
  public getMaskDate(value: Date): string {
    let result = "";
    if (value === null || value === undefined) {
      return;
    }
    //if (value.getFullYear() == 1700) {
      let year = value.getFullYear().toString();
      let month = value.getMonth().toString();
      let day = value.getDate().toString();

      year = year.substr(0, 1) + "***";
      month = month.length > 1 ? month.substr(0, 1) + "*" : "0*";
      day = day.length > 1 ? "*"+ day.substr(1, 1)  : "*"+ day;

      result = year + "-" + month + "-" + day;
    //}
    return result;
  }

  public getMaskNumber(value: number): string {
    let result = "";
    if (value === null || value === undefined) {
      return;
    }
    result = value.toString();
    let tempStr = "";
    const tam = result.length;
    for (let i = 1; i < tam - 1; i++) {
      tempStr += "*";
    }
    result = result.substr(0, 1) + tempStr + result.substr(tam - 1, 1);
    return result;
  }


  public getMaskMaritalStatus(value: string, maritalStatusTypes: models.Options[]): string {
    let result = "";
    if (value === null || value === undefined || maritalStatusTypes === undefined|| maritalStatusTypes.length === 0) {
      return;
    }
    result = maritalStatusTypes.find(el => el.description == value).value;
    let tempStr = "";
    const tam = result.length;
    for (let i = 0; i < tam - 1; i++) {
      tempStr += "*";
    }
    result = tempStr + result.substr(tam - 1, 1);
    return result;
  }
}
